/*
 * Copyright © 2021 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function RedirectPageController($rootScope, $log, $location, userService, keycloakService) {

    var vm = this;

    vm.$onInit = function () {
        handleCallback()
    }

    function handleCallback() {
        const code = $location.search().code;
        keycloakService.processCallback(code).then((session) => {
            const token = session.access_token;
            const refreshToken = session.refresh_token;
            const idToken = session.id_token;
            userService.setUserFromJwtToken(token, refreshToken, true, false, false, idToken);
        }).catch((e) => {
            $log.error('Failed to exchange code for tokens: ', e);
            $rootScope.$broadcast('unauthenticated', true, e || 'Authentication failed. Please contact your system administrator.');
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/login/redirect-page.controller.js